import {
  CalendarPropsSingle,
  Calendar as OriginalCalendar,
} from '@agro1desenvolvimento/react-components';
import { classNames } from 'primereact/utils';
import InputEnhancements, { FormInputEnhancements } from './input-enhancements';
import WithController from '../with-controller';

const Calendar = WithController<PropTypes, Date>(
  ({
    field,
    fieldState,
    addonRight,
    addonLeft,
    label,
    withErrorMessage,
    containerClassName,
    formState: _formState,
    className,
    onChange,
    triggerDependencies,
    ...props
  }) => (
    <InputEnhancements
      addonRight={addonRight}
      addonLeft={addonLeft}
      label={label}
      withErrorMessage={withErrorMessage}
      containerClassName={containerClassName}
      field={field}
      fieldState={fieldState}
    >
      <OriginalCalendar
        {...props}
        inputId={field.name}
        name={field.name}
        inputRef={field.ref}
        value={field.value}
        onBlur={field.onBlur}
        onChange={(event) => {
          field.onChange(event.value);
          if (onChange) onChange(event);
          triggerDependencies();
        }}
        className={classNames({ 'p-invalid': fieldState.error }, className)}
      />
    </InputEnhancements>
  ),
);

type OmittedProps =
  | 'inputId'
  | 'name'
  | 'inputRef'
  | 'value'
  | 'onBlur'
  | 'onValueChange';

type PropTypes = Omit<CalendarPropsSingle, OmittedProps> &
  FormInputEnhancements;

export default Calendar;
